import styles from "./PolicyLoading.module.css";

export default function PolicyLoading(): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.text}>Loading...</div>
    </div>
  );
}
